module.exports = __webpack_public_path__ + "media/images/lp_v6_img18-6b960e632fd0d560d10b41660a84654d.webp";